import { UntypedFormGroup } from '@angular/forms';
import { DYNAMIC_FORM_CONTROL_TYPE_GROUP } from '@ng-dynamic-forms/core';
import isNil from 'lodash/isNil';
import { AnyFormControlModel } from '../dynamic-form-components/shared-models/any-form-control.model';

export function formElementsInvalid(formGroup: UntypedFormGroup, formModel: AnyFormControlModel[]): boolean {
  return (
    !!formGroup.errors ||
    formModel
      .filter(element => !element.hidden)
      .some((model: AnyFormControlModel) => {
        const control = formGroup.controls[model.id];
        if (model.type === DYNAMIC_FORM_CONTROL_TYPE_GROUP) {
          return formElementsInvalid(control as UntypedFormGroup, model.group);
        } else {
          return (
            control.invalid ||
            (model.required &&
              (isNil(control.value) ||
                control.value === '' ||
                (!model.additional?.paperProcessOverride && Array.isArray(control.value) && !control.value.length)))
          );
        }
      })
  );
}
